import React, { useCallback, useEffect, useState } from "react";
import * as styles from "./OTPWithResendSubmit.module.css";
import { OTPInput } from "../Inputs";
import { showToast } from "../ToastComponent";

const Resend = ({ initialRetryTime, otpResendAPI }) => {
  const [retryTime, setRetryTime] = useState({ value: initialRetryTime });
  const [timer, setTimer] = useState(0);
  const [loadingState, setLoadingState] = useState("");

  const resendOTP = useCallback(async () => {
    setLoadingState("Loading");
    const response = await otpResendAPI();
    const data = await response.json();
    showToast(data?.message);
    if (data.retryDuration) {
      setLoadingState("");
      setRetryTime({ value: data.retryDuration });
    } else {
      setLoadingState("Exceeded Maximum Retries");
    }
  }, [otpResendAPI]);

  useEffect(() => {
    const initialSeconds = parseInt(retryTime.value) / 1000;
    setTimer(initialSeconds);

    let currentTime = initialSeconds;

    const interval = setInterval(() => {
      currentTime -= 1;
      setTimer(currentTime);

      if (currentTime <= 0) {
        clearInterval(interval);
      }
    }, 1000); // 1 second interval for countdown

    return () => clearInterval(interval); // cleanup
  }, [retryTime]);

  return (
    <div>
      <h6>Didn't Receive the otp ? </h6>
      {timer ? (
        <p className={styles.sign_up}>Retry in {timer} seconds</p>
      ) : loadingState ? (
        <p>{loadingState}</p>
      ) : (
        <a
          onClick={() => {
            if (!loadingState) resendOTP();
          }}
          className={styles.sign_up_a}
        >
          Retry now
        </a>
      )}
    </div>
  );
};

const OTPInputWithSubmit = ({ otpVerifyAPI, onOTPVerified }) => {
  const [enteredOTP, setEnteredOTP] = useState("");

  const onOTPSubmit = async () => {
    const response = await otpVerifyAPI({ otp: enteredOTP });
    const data = await response.json();
    showToast(data?.message);
    if (response.status === 200 && onOTPVerified) {
      onOTPVerified();
    }
  };

  return (
    <>
      <h3 className={styles.signup_h3}>Please enter the otp</h3>
      <OTPInput onOTPComplete={setEnteredOTP} OTPlength={6} />
      <button
        type="submit"
        onClick={onOTPSubmit}
        disabled={!enteredOTP}
        className={styles.submit_button}
      >
        Confirm
      </button>
    </>
  );
};

const OTPWithResendSubmit = ({
  initialRetryTime,
  otpVerifyAPI,
  otpResendAPI,
  onOTPVerified,
}) => {
  return (
    <div className={styles.divcontainer}>
      <h1 className={styles.sign_in_Heading}>OTP</h1>
      <OTPInputWithSubmit
        otpVerifyAPI={otpVerifyAPI}
        onOTPVerified={onOTPVerified}
      />
      <Resend initialRetryTime={initialRetryTime} otpResendAPI={otpResendAPI} />
    </div>
  );
};

export default OTPWithResendSubmit;
